import { render, staticRenderFns } from "./TagsAdicionaisModalForm.vue?vue&type=template&id=3a4044ef&scoped=true&"
import script from "./TagsAdicionaisModalForm.vue?vue&type=script&lang=js&"
export * from "./TagsAdicionaisModalForm.vue?vue&type=script&lang=js&"
import style0 from "./TagsAdicionaisModalForm.vue?vue&type=style&index=0&id=3a4044ef&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a4044ef",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VIcon,VTooltip})
